export enum eTypeAsnProcess {
  Inbound = 1, // Ingreso
  Return = 2, // Devolución
  Replenishment = 3 // Reabastecimiento
}
